import { render, staticRenderFns } from "./R01.vue?vue&type=template&id=4cd84aea&scoped=true"
import script from "./R01.vue?vue&type=script&lang=js"
export * from "./R01.vue?vue&type=script&lang=js"
import style0 from "./R01.vue?vue&type=style&index=0&id=4cd84aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd84aea",
  null
  
)

export default component.exports